import React, { useEffect } from 'react';
import liracrypt from './Liracrypt/liracrypt';
import { message, notification } from 'antd';
import ApiErrorComp from './ApiErrorComp/ApiErrorComp';
import noImg from '../assets/static/noImg.jpeg';
const ImgDisplay = ({
    style = {},
    params,
    api = '/imagecontrol',
}) => {
    const [img, setImg] = React.useState(null);
    useEffect(() => {
        liracrypt.get(api, { ...params })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setImg(data.data);
                } else {
                    setImg(noImg);
                }
            }).catch((err) => {
                console.error(err)
                setImg(noImg);
            })
    }, []);

    return (
        <div className="image-display" style={{ display: 'block', margin: 'auto', ...style }}>
            {
                img ?
                    <img src={img} loading='true' alt="Placeholder" style={{ width: '100%', height: '100%' }} /> :
                    null
            }
        </div>
    );
};

export default ImgDisplay;